import axios from 'axios';
import { getEnv } from '../env/env.manager';

const env = getEnv();
const baseURL = env.baseURL;
const timeout = env.networkHealthTimeout;

export default function checkInternetConnection() {
    return axios({
        method: 'head',
        url: `${baseURL}/utils/healthCheck`,
        timeout: timeout
      });
}

